import React from 'react';
import { navigate } from 'gatsby';
import {
  Box,
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Paginator from './utils/Paginator';

const mapStatuses = {
  new: 'Utworzono',
  in_progress: 'W trakcie',
  manual_verification_pending: 'W trakcie weryfikacji',
  completed: 'W trakcie weryfikacji',
  accepted: 'Zaakceptowano',
  rejected: 'Odrzucono',
};

const mapTypes = {
  individual: 'Osoba fizyczna',
  sole_proprietorship: 'Jednoosobowa działalność gospodarcza',
  company: 'Spółka lub fundacja',
};

const mapVerMethods = {
  fiberpay_transfer: 'Przelew weryfikacyjny',
  banqup: 'Dane konta bankowego',
};

const getName = order => {
  const {
    companyName,
    firstName,
    lastName,
  } = order.formAnswers;
  if (companyName) return companyName.answer;
  if (firstName && lastName) return `${firstName.answer} ${lastName.answer}`;
  return <i>brak danych</i>;
};

const OrdersTable = ({
  orders,
  detailsUri = '/dashboard/orders',
}) => (
  <Table selectable>
    <TableHead>
      <TableRow>
        <TableCell>Kod zlecenia</TableCell>
        <TableCell>Typ</TableCell>
        <TableCell>Status</TableCell>
        <TableCell>Metoda weryfikacji</TableCell>
        <TableCell>Status weryfikacji</TableCell>
        <TableCell>Nazwa</TableCell>
        <TableCell>Utworzono</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {orders.length ? (
        <>
          {orders.map(o => (
            <TableRow
              key={o.code}
              onClick={() => navigate(`${detailsUri}/${o.code}`)}
              style={{ cursor: 'pointer' }}
            >
              <TableCell>{o.code}</TableCell>
              <TableCell>{mapTypes[o.type]}</TableCell>
              <TableCell>{mapStatuses[o.status]}</TableCell>
              <TableCell>
                {mapVerMethods[o.identityVerificationMethod] || (
                  <i>nie wybrano</i>
                )}
              </TableCell>
              <TableCell>{mapStatuses[o.identityVerificationStatus]}</TableCell>
              <TableCell>{getName(o)}</TableCell>
              <TableCell>{o.createdAt}</TableCell>
            </TableRow>
          ))}
        </>
      ) : (
        <TableRow>
          <TableCell colSpan={7}>
            Nie znaleziono zleceń spełniających kryteria wyszukiwania
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
);

const createParams = (filters, search) => {
  const params = Object.entries(filters)
    .reduce((acc, [name, value]) => {
      if (!value) return acc;
      return {
        ...acc,
        [`filter[${name}]`]: value,
      };
    }, {});

  if (search.length > 2) {
    params.search = search;
  }
  return params;
};

const OrdersList = ({
  orders,
  fetchOrders,
  filters,
  search,
  renderFilters,
  detailsUri,
  children,
}) => (
  <Paginator
    resource={orders}
    params={createParams(filters, search)}
    getResource={params => fetchOrders(params)}
    render={(o, paginationFooter, loading, error) => (
      <Box>
        <Box pb={2} textAlign="center">
          <Typography variant="h5" paragraph>
            Lista zleceń
          </Typography>
        </Box>
        {children}
        {renderFilters()}
        {loading ? (
          <Box textAlign="center">
            <CircularProgress loading="true" />
          </Box>
        ) : (
          <>
            {error ? (
              <Alert severity="error">{error}</Alert>
            ) : (
              <TableContainer>
                <OrdersTable orders={o} detailsUri={detailsUri} />
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item>
                    <Box py={2}>{paginationFooter()}</Box>
                  </Grid>
                </Grid>
              </TableContainer>
            )}
          </>
        )}
      </Box>
    )}
  />
);

export default OrdersList;
